import { ExpiredOfflineObjectAsyncTimestampRemover } from '../abstract/expired-offline-object-async-timestamp-remover';
import { ImmoIPImmoTaskChangesObject } from './immo-ip-immo-task-changes-object';

export class ExpiredImmoIPImmoTaskChangesRemover extends ExpiredOfflineObjectAsyncTimestampRemover<
  number,
  ImmoIPImmoTaskChangesObject
> {}
